import React, {useEffect, useMemo, useState} from 'react';
import {Button, Col, Input, Modal, notification, Row, Table} from 'antd';
import Spinner from "../../spinner";
import i18n from "../../../i18n";
import {legalEntityService} from "../../../services/legal-entity.service";

export default function LegalEntityInfoGosLog({isShow, setIsShow, legalEntityId, consignorId}) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [docs, setDocs] = useState([]);
  const [numberExtract, setNumberExtract] = useState('');
  const [showNumberExtractEditor, setShowNumberExtractEditor] = useState(false);

  const getErrorDescription = (err) => {
    if (typeof err === 'string') {
      return err;
    }
    if (err && err.message) {
      return err.message;
    }
    return i18n.t('components.notification.errors.default');
  };

  const normalizeDocs = (docsData) => {
    if (Array.isArray(docsData)) {
      return docsData;
    }
    if (docsData && typeof docsData === 'object') {
      if (
        typeof docsData.Url !== 'undefined' ||
        typeof docsData.Name !== 'undefined' ||
        typeof docsData.ReadableName !== 'undefined' ||
        typeof docsData.Extension !== 'undefined'
      ) {
        return [docsData];
      }
      return Object.keys(docsData)
        .map((key) => docsData[key])
        .filter((item) => item && typeof item === 'object');
    }
    return [];
  };

  useEffect(() => {
    if (!isShow || !legalEntityId || !consignorId) {
      return;
    }

    setLoading(true);
    legalEntityService.getGosLogInfo(legalEntityId, consignorId)
      .then((response) => {
        setDocs(normalizeDocs(response && response.Docs ? response.Docs : []));
        setNumberExtract(response && response.number_extract ? response.number_extract : '');
        setShowNumberExtractEditor(
          !!(response && response.number_extract !== null && String(response.number_extract).trim() !== '')
        );
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.error'),
          description: getErrorDescription(err),
        });
        setIsShow(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isShow, legalEntityId, consignorId, setIsShow]);

  const docsColumns = useMemo(() => ([
    {
      title: 'Документ',
      key: 'name',
      render: (record) => record.ReadableName || record.Name || '-',
    },
    {
      title: 'Формат',
      key: 'extension',
      render: (record) => record.Extension || '-',
    },
    {
      title: '',
      key: 'action',
      render: (record) => (
        <a href={record.Url} target="_blank" rel="noopener noreferrer">
          {i18n.t('main.buttons.open')}
        </a>
      ),
    },
  ]), []);

  const hasNumberExtract = numberExtract !== null && String(numberExtract).trim() !== '';

  const handleChangeNumberExtract = () => {
    setSaving(true);
    legalEntityService.changeNumberExtract(consignorId, legalEntityId, numberExtract)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.success'),
          description: response && response.message ? response.message : '',
        });
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.error'),
          description: getErrorDescription(err),
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal
      title="Информация ГосЛог"
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => setIsShow(false)}
      footer={null}
      width={760}
    >
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={docsColumns}
              dataSource={docs}
              rowKey={(record, index) => `${record.Name || 'doc'}-${index}`}
              pagination={false}
              locale={{emptyText: 'Документы отсутствуют'}}
              size="small"
            />
          </Col>
          {showNumberExtractEditor && (
              <>
                <Col span={16}>
                  <div
                      style={{display: 'block', marginBottom: '6px', minHeight: '22px', lineHeight: '22px', color: '#262626', fontWeight: 600, fontSize: '14px'}}
                  >
                    <span>Номер выписки</span>
                  </div>
                  <Input
                      id="numberExtract"
                      value={numberExtract}
                      onChange={(e) => setNumberExtract(e.target.value)}
                      placeholder="Введите номер выписки"
                  />
                </Col>
                <Col span={8}>
                  <div style={{marginBottom: '6px', minHeight: '22px', lineHeight: '22px', visibility: 'hidden', fontWeight: 600, fontSize: '14px'}}>
                    Номер выписки
                  </div>
                  <Button
                      type="primary"
                      className="typical-btn-green"
                      style={{width: '100%'}}
                      onClick={handleChangeNumberExtract}
                      disabled={!String(numberExtract).trim()}
                      loading={saving}
                  >
                    Изменить
                  </Button>
                </Col>
              </>
          )}
        </Row>
      </Spinner>
    </Modal>
  );
}
